//
//
//
//
//
//
//
//

import inobounce from "inobounce";
import { getUrlParams } from './api/getApi'

export default {
  name: "APP",
  provide() {
    return {
      reloadView: this.reloadView
    };
  },
  data() {
    return {
      isRouterReload: true,
      excludeComponent: [
        "registerPhone",
        "userInfo",
        "studyTour",
        "registerEmail",
        "passwordReset",
        "accountMobileNumber",
        "accountMailbox",
        "changePassword",
        "ActiveCommodities",
        "AllRedemption",
        "AccountManage",
        "AmentNumber",
        "receiptTransform",
        "myTicket",
        "PerformanceList"
      ]
    };
  },
  created() {
    let u = navigator.userAgent;
    if (u.indexOf("iPhone") > -1) {
      inobounce.enable();
    }

    const { origin, user_token } = getUrlParams(window.location.href)
    console.log('origin:', origin, '----user_token:', user_token);
    if (origin) {
      console.log('origin:', origin)
      localStorage.setItem('origin', origin)
      sessionStorage.setItem('origin', origin)
    }
    if (user_token) {
      console.log('user_token:', user_token)
      localStorage.setItem('user_token', user_token)
      sessionStorage.setItem('user_token', user_token)
    }

  },
  beforeDestroy() {
    inobounce.disable();
  },
  /*    mounted: function () {
      console.log(this.mui.init);
      this.mui.init({
        keyEventBind: {
          backbutton: true,  //Boolean(默认true)关闭back按键监听
          menubutton: true   //Boolean(默认true)关闭menu按键监听
        },
      });
      this.mui.back = function(){
      }
    },*/
  methods: {
    // 刷新当前页面
    reloadView() {
      this.isRouterReload = false;
      this.$nextTick(function () {
        this.isRouterReload = true;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue